import React from "react";
import PropTypes from "prop-types";
import { shortDate } from "LIB/formatters/date";
import { EditButton } from "MODULES/shared/components";
import EditShipping from "../Edit/EditShipping";

export default class ShippingDetails extends React.Component {
  state = {
    editShippingModalOpen: false
  };

  openShippingModal = () => {
    this.setState({ editShippingModalOpen: true });
  };

  closeShippingModal = () => this.setState({ editShippingModalOpen: false });
  render() {
    const { purchaseOrder, unlocked = true } = this.props;
    const { editShippingModalOpen } = this.state;

    return (
      <div>
        <h2>
          Shipping
          {unlocked && <EditButton handleClick={this.openShippingModal} />}
          <EditShipping
            purchaseOrder={purchaseOrder}
            open={editShippingModalOpen}
            close={this.closeShippingModal}
          />
        </h2>
        <table className="table table-condensed">
          <tbody>
            <tr>
              <th className="text-right">FOB</th>
              <td>{purchaseOrder.fob}</td>
            </tr>
            <tr>
              <th className="text-right">Ship Date</th>
              <td>{shortDate(purchaseOrder.ship_date)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

ShippingDetails.propTypes = {
  purchaseOrder: PropTypes.instanceOf(Object),
  unlocked: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/ShippingDetails.jsx